import { withStyles, makeStyles } from "@mui/styles";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import Typography from "@mui/material/Typography";

const styles = (theme) => ({
  root: {
    margin: 0,
    backgroundColor: "#006fca",
    color: "#FFF",
    padding: "6px 12px",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
    padding: "0 6px",
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="subtitle2">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          size="large"
        >
          <Icon>close</Icon>
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    marginLeft: 0,
  },
}))(MuiDialogActions);

export default function CustomizedDialogs(props) {
  const { title, open, children, renderFooter, handleClose, maxWidth } = props;
  const useStyles = makeStyles({
    root: {
      overflowY: "unset",
    },
  });
  const classes = useStyles();
  return (
    <Dialog
      scroll={"body"}
      className={classes.root}
      onClose={handleClose}
      open={open}
      fullWidth={true}
      maxWidth={maxWidth}
    >
      <DialogTitle onClose={handleClose}>{title}</DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
      {renderFooter && <DialogActions>{renderFooter} </DialogActions>}
    </Dialog>
  );
}

CustomizedDialogs.defaultProps = {
  open: false,
};
